import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ParameterService } from 'src/app/shared/service/params/param';
import { LocalStorageService } from 'src/app/shared/service/storage/localstorage.service';
import { ProjetIndicateurService } from '../../plananalytique/programme/projet-indicateur/projet-indicateur.component';
import { Router } from '@angular/router';
import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-pai',
  standalone: false,
  templateUrl: './pai.component.html',
  styleUrl: './pai.component.scss'
})

export class PaiComponent {

  annee: any;
  items: any = [] = [];
  firstProjets: number = 0;
  rowsProjets: number = 10;
  totalRecords: number = 0;
  paginatedProjets: any = [];
  user: any;
  directionItems: any = [];
  directionId: any;
  isLoading: boolean = false;
  dateFin: any;
  dateDebut: any;
  constructor(
    private modalService: NgbModal,
    private paramservice: ParameterService,
    private localstorage: LocalStorageService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private projetService: ProjetIndicateurService,
    private ngxService: NgxUiLoaderService,
    private router: Router
  ) {
    this.annee = this.localstorage.getExerciceToUserToSuivieEvaluation();
    // Initialize dates based on the exercise year
   const exercice = this.localstorage.getExerciceToUserToSuivieEvaluation();

    this.dateDebut = `${exercice}-01-01`;
    this.dateFin = new Date().toISOString().split('T')[0];

  }
  ngOnInit() {
    this.user = this.localstorage.getInfoUserToService()?.data;
    //console.log("  this.user", this.user);
    this.directionId = this.user?.service?.direction?.reference

  }
  getStatistique() {
    if (this.dateDebut === null || this.dateDebut === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (this.dateFin === null || this.dateFin === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }

    this.ngxService.start();
    const requestData = {
      annee: this.annee,
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      //   dirdection_id: this.directionId,
      user_reference: this.user.reference,
      type_operation: 'data'

    }
    this.paramservice.getStatistiquePtaPlanInvestissement(requestData).subscribe(
      (response: any) => {
        this.ngxService.stop();
        // this.isLoading = false;
        this.items = response.data;
        this.totalRecords = this.items.length;
        this.updatePaginatedProjets();
      },
      (error) => {
        this.ngxService.stop();
        this.messageService.add({ severity: 'error', summary: 'TEP', detail: error, life: 3000 });
        //this.isLoading = false;
      }
    );
  }
  onPageChangeProjets(event) {
    this.firstProjets = event.page * this.rowsProjets; // Mise à jour de la page actuelle
    this.updatePaginatedProjets();
  }

  // Méthode pour mettre à jour les données paginées des projets
  updatePaginatedProjets() {
    const start = this.firstProjets;
    const end = start + this.rowsProjets;
    this.paginatedProjets = this.items.slice(start, end);
  }//end updatePaginatedProjets
  getDirection() {

    this.paramservice.fetchDataDirection().subscribe(

      (response: any) => {

        ////console.log("la reponse du webservice", response);

        this.directionItems = response.data;

      },
      (error) => {

        ////console.log("une erreur est survenu", error);

      }
    )
  }

  exportToDocument(typeDoc: any) {
    // Ensure dates are set with defaults if not provided
    if (!this.dateDebut || this.dateDebut === '') {
      this.dateDebut = this.annee ? `${this.annee}-01-01` : '';
    }
    if (!this.dateFin || this.dateFin === '') {
      this.dateFin = this.annee ? `${this.annee}-12-31` : '';
    }

    if (this.dateDebut === '' || this.dateDebut === null || this.dateDebut === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de début', life: 3000 });
      return;
    }
    if (this.dateFin === '' || this.dateFin === null || this.dateFin === undefined) {
      this.messageService.add({ severity: 'error', summary: 'TEP', detail: 'Veuillez renseigner la date de fin', life: 3000 });
      return;
    }
    const requestData = {
      annee: this.annee,
      date_debut: this.dateDebut,
      date_fin: this.dateFin,
      // direction_id: this.directionId,
      user_reference: this.user.reference,
      type_operation: typeDoc

    }
    this.ngxService.start();


    this.paramservice.getStatistiquePtaPlanInvestissementDoc(requestData).subscribe(
      (response: Blob) => {
        let filename = '';
        let mimeType = '';
        let successMessage = '';

        if (typeDoc === 'pdf') {
          filename = 'Statistiques_pai.pdf';
          mimeType = 'application/pdf';
          successMessage = 'Le fichier PDF a été téléchargé avec succès';

          const blob = new Blob([response], { type: mimeType });
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
        } else {
          filename = 'Statistiques_pai.xlsx';
          mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          successMessage = 'Le fichier Excel a été téléchargé avec succès';

          const blob = new Blob([response], { type: mimeType });
          FileSaver.saveAs(blob, filename);
        }

        this.ngxService.stop();
        this.messageService.add({ severity: 'success', summary: 'Téléchargement réussi', detail: successMessage, life: 3000 });
      },
         (error: any) => {
        this.ngxService.stop();

        if (error.error instanceof Blob) {

          const reader = new FileReader();

          reader.onload = () => {
            try {
              const err = JSON.parse(reader.result as string);

              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: err.message || 'Téléchargement échoué'
              });

            } catch (e) {
              this.messageService.add({
                severity: 'error',
                summary: 'Erreur',
                detail: 'Erreur lors du traitement du message'
              });
            }
          };

          reader.readAsText(error.error);

        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: error.error?.message || 'Téléchargement échoué'
          });
        }
      }
    );

  }

}
